import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import Box from 'ui-box';
import { Typography } from 'antd';
import TextAreaField from '../form-helpers/TextAreaField';

const { Title } = Typography;

const styles = {
  question: {
    fontWeight: "600", 
    fontSize: "24px", 
    lineHeight: "30px", 
    textAlign: "center", 
    color: "#404047",
    marginBottom: 25,
    marginTop: 50
  }
}

const MobileTextAreaQuestion = ({fieldName, question}) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      {
        question && (
          <Title level={4} style={styles.question}>
            {t(`${question}`)}
          </Title>
        )
      }
      <TextAreaField
        name={fieldName}
        style={{ width: '100%', padding: '3%' }}
        onChange={(e) => setFieldValue(fieldName, e.target.value)}
        rows={6}
      />
    </>
  );
}

export default MobileTextAreaQuestion;
